import { Modal } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect } from "react";
import { useFormik } from "formik";
import CustomButton from "../Buttons/Button";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import { useDispatch } from "react-redux";
import SelectField from "../inputs/SelectField";
import CustomInput from "../inputs/CustomInput";
import { broadcastNotification } from "../../store/actions/pushNotifications/broadcastNotification";
import { pushNotificationSchema } from "../../Helper/validationSchemas";

function SendNotification({ open, onClose }) {
  const dispatch = useDispatch();

  const handleSubmit = (values) => {
    let data = {
      title: values?.title,
      body: values?.body,
      provider: "fcm",
      data: {
        screen: "Inbox",
        type: "broadcast",
      },
      chunk_size: 500,
    };

    dispatch(
      broadcastNotification({
        data,

        callback: () => {
          form.setSubmitting(false);
          onClose();
          console.log("dsdsddddd");
        },
        fail: () => {
          console.log("dsdsd");

          form.setSubmitting(false);
        },
      }),
    );
  };

  const form = useFormik({
    initialValues: {
      title: "",
      body: "",
    },
    validationSchema: pushNotificationSchema,
    onSubmit: handleSubmit,
  });

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="custom-modal-title"
        aria-describedby="custom-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "background.paper",
            borderRadius: "10px",
            boxShadow: 24,
            p: 2,
          }}
        >
          <IconButton
            aria-label="close"
            sx={{
              position: "absolute",
              top: 19,
              right: 10,
            }}
            onClick={onClose}
          >
            <ClearIcon />
          </IconButton>

          <div className="w-full p-5">
            <div>
              <h1 className="font-[500] text-2xl mb-4">
                Send Push Notificaiton
              </h1>

              <div className=" w-full items-center mr-4">
                <div className="mb-6   w-full ">
                  <p className="">Title:</p>
                  <CustomInput
                    id="title"
                    width="100%"
                    form={form}
                    placeholder={"Enter Title"}
                    height="16px"
                    mt="10"
                    mr="10px"
                    mb="10px"
                    borderRadius={"4px"}
                    className="mobile-input-width"
                  />
                </div>
                <div className="mb-6  w-full ">
                  <p className="">Body:</p>
                  <CustomInput
                    id="body"
                    width="100%"
                    form={form}
                    placeholder={"Enter Body"}
                    height="16px"
                    mt="10"
                    mr="10px"
                    mb="10px"
                    borderRadius={"4px"}
                    className="mobile-input-width"
                  />
                </div>

                {/* <label>Send to</label>
                <div className="mb-4">
                  <SelectField
                    id="sendTo"
                    options={[
                      {
                        label: "All",
                        value: "All",
                      },
                      {
                        label: "Selected",
                        value: "Selected",
                      },
                    ]}
                    form={form}
                    sx={{
                      width: "432px",
                      height: "48px",
                      borderRadius: "7px",
                      borderColor: "#D0D5DD",
                      color: "#101828",
                    }}
                    fw={400}
                    fz={"16px"}
                  />
                </div> */}

                <div className="flex mt-10 w-full items-center">
                  <CustomButton
                    variant="outlined"
                    customColor="#fff"
                    children="Cancel"
                    width="100%"
                    onClick={onClose}
                    height="50px"
                    borderColor="#D0D5DD"
                    margin="0px 25px 0px 0px"
                    color="#159AA8"
                    iconWidth="22px"
                  />

                  <CustomButton
                    variant="contained"
                    customColor="#159AA8"
                    loading={form.isSubmitting}
                    children={"Submit"}
                    width="100%"
                    height="50px"
                    padding="10px"
                    disabled={!form?.isValid || form.isSubmitting}
                    onClick={form.handleSubmit}
                  />
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default SendNotification;
